export default "__VITE_ASSET__dda354aa__"